import React, { useState } from "react";
import PropTypes from "prop-types";

function VideoPlayer({ videoUrl, videoSources, thumbnailUrl, altText, className }) {
    const [isPlaying, setIsPlaying] = useState(false);
    const [showControls, setShowControls] = useState(false);

    const handlePlayClick = () => {
        setIsPlaying(true);
        setShowControls(true);
    };

    return (
        <div className={className || ""}>
            <div className="video-player-wrapper">
                {!isPlaying ? (
                    <div 
                        className="video-thumbnail-container" 
                        onClick={handlePlayClick}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handlePlayClick();
                            }
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        <img
                            src={thumbnailUrl}
                            alt={altText || "Video thumbnail"}
                            className="video-thumbnail"
                        />
                        <button
                            className="video-play-button"
                            aria-label="Play video"
                            type="button"
                        >
                            <svg
                                width="72"
                                height="72"
                                viewBox="0 0 72 72"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="36"
                                    cy="36"
                                    r="36"
                                    fill="rgba(0, 0, 0, 0.7)"
                                />
                                <path
                                    d="M48 36L27 48V24L48 36Z"
                                    fill="white"
                                />
                            </svg>
                        </button>
                    </div>
                ) : (
                    <video
                        controls={showControls}
                        autoPlay
                        onEnded={() => {
                            setIsPlaying(false);
                            setShowControls(false);
                        }}
                    >
                        {videoSources && videoSources.length > 0 ? (
                            videoSources.map((source) => (
                                <source
                                    key={source.type}
                                    src={source.src}
                                    type={source.type}
                                />
                            ))
                        ) : (
                            <source src={videoUrl} type="video/mp4" />
                        )}
                        <track kind="captions" />
                        Your browser does not support the video tag.
                    </video>
                )}
            </div>
        </div>
    );
}

VideoPlayer.propTypes = {
    videoUrl: PropTypes.string,
    videoSources: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string.isRequired,
            type: PropTypes.string.isRequired
        })
    ),
    thumbnailUrl: PropTypes.string.isRequired,
    altText: PropTypes.string,
    className: PropTypes.string
};

VideoPlayer.defaultProps = {
    videoUrl: "",
    videoSources: [],
    altText: "Video thumbnail",
    className: ""
};

export default VideoPlayer;